import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Salad, ArrowRight } from "lucide-react";

/**
 * Cross-navigation strip on the Personal Chef landing page pointing to
 * the new MarFit Meals product. Matches the warm rose Personal Chef
 * palette on the entry side and hints at the terracotta/sage MarFit
 * palette on the CTA button to prime the visual transition.
 */
export const MarfitCrossNav = () => (
    <section
        className="relative py-16 md:py-24"
        style={{
            background: "linear-gradient(180deg, #faf5ee 0%, #f4ebd9 100%)",
        }}
        data-testid="marfit-crossnav-section"
    >
        <div className="max-w-4xl mx-auto px-5">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] items-center gap-6 md:gap-10 bg-white rounded-3xl px-6 py-8 md:px-10 md:py-10 shadow-[0_20px_50px_-30px_rgba(0,0,0,0.2)] ring-1 ring-stone-200/70"
            >
                {/* Visual token */}
                <div
                    className="w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center shrink-0"
                    style={{
                        background: "linear-gradient(135deg,#c67b3f 0%,#7a9058 100%)",
                        color: "#faf5ea",
                    }}
                    aria-hidden
                >
                    <Salad size={32} strokeWidth={1.5} />
                </div>

                {/* Copy */}
                <div className="text-center md:text-left">
                    <p
                        className="text-[11px] tracking-[0.32em] uppercase mb-2"
                        style={{ color: "#7a9058" }}
                    >
                        Novo · MarFit Meals
                    </p>
                    <h3 className="font-serif text-2xl md:text-3xl leading-snug text-stone-900">
                        E se não tiveres tempo para a semana toda?
                    </h3>
                    <p className="mt-2 text-sm md:text-base text-stone-600 max-w-md">
                        Marmitas fitness, frescas, prontas a comer. A mesma cozinha, agora entregue à tua porta.
                    </p>
                </div>

                {/* CTA */}
                <Link
                    to="/marmitas"
                    data-testid="crossnav-to-marfit"
                    className="inline-flex items-center gap-2 rounded-full px-6 py-3 font-medium text-sm shrink-0 transition-transform hover:scale-105 whitespace-nowrap"
                    style={{
                        background: "#3d2e1f",
                        color: "#faf5ea",
                    }}
                >
                    Ver MarFit Meals
                    <ArrowRight size={16} />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default MarfitCrossNav;
